import { useTranslation } from 'react-i18next'

export default function AmazonSalesBanner() {
  const { t } = useTranslation('landingPage')

  return (
    <div className='bg-mi-on-surface-accent-secondary py-2 text-center text-white text-base font-semibold leading-[25px] tracking-[-0.41px]'>
      <span>{t('amazonSalesBanner.title')}</span>
      <br />
      <span>{t('amazonSalesBanner.period')}</span>
    </div>
  )
}
